<template>
  <div>{{ status }}</div>
</template>
<script>
import Vue from "vue";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

export default {
  components: {},
  data() {
    return {
      status: "init"
    };
  },
  methods: {
    doesTokenNeedToRefresh() {
      let timestamp = Math.floor(Date.now() / 1000);
      let timeToGo = parseInt(localStorage.getItem("expires_on")) - timestamp;
      if (!localStorage.getItem("refresh_token")) {
        this.status = "Refresh token missing, probably refreshing already";
        return;
      }

      if (timeToGo > 60) {
        this.status = "At least another " + (timeToGo - 60) + " seconds";
        return;
      }

      this.refreshToken();
    },
    refreshToken() {
      this.status = "Refreshing...";

      this.notifyVue(
        "Gebruikerssessie vernieuwen...",
        "hourglass_top",
        "success",
        5000
      );

      let timestamp = Math.floor(Date.now() / 1000);

      const refreshToken = localStorage.getItem("refresh_token");
      // Can only be used once. Remove to prevent other refreshes from becoming active as well
      localStorage.removeItem("refresh_token");

      this.$http
        .post(
          Vue.prototype.$apiBaseUrl + "refresh",
          { refresh_token: refreshToken },
          { emulateJSON: true }
        )
        .then(
          response => {
            localStorage.setItem(
              "expires_on",
              timestamp + response.data.expires_in
            );
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);

            this.status = "Refreshing done!";

            this.notifyVue(
              "Gebruikerssessie succesvol vernieuwd.",
              "check",
              "success",
              5000
            );
          },
          response => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("expires_on");
            localStorage.removeItem("refresh_token");

            this.status = "Refreshing ERROR!!!";

            this.notifyVue(
              "Het vernieuwen van de gebruikerssessie is mislukt. Log opnieuw in.",
              "add_alert",
              "danger",
              0
            );
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {
    setInterval(this.doesTokenNeedToRefresh, 10000);
  }
};
</script>
<style lang="scss" scoped>
div {
  display: none;
}
</style>
